import { getCookie, setCookie } from '../../../util/cookies';
import { COOKIE_NAME, COOKIE_VALUE } from '../../../util/cookie-consent';
import config from '../../../util/load-config';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { ClientOnly } from 'components/_shared/widgets/render-control';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

const Popup = dynamic(() => import('./popup'));

/**
 * NOTE: for the most part we're supposed to ALWAYS "show" the popup.
 * But on a few very specific paths we might need to disable that.
 * For now the only example is a page used as a webview for the mobile app.
 */
const EXCLUDED_PATHS = ['/payment/peach-widget'];

const COOKIE_AGE = 90;
const TIMEOUT = 3000;

const CookieConsent = () => {
  const { pathname } = useRouter();
  const excluded = useMemo(() => EXCLUDED_PATHS.includes(pathname), [pathname]);

  const [show, setShow] = useState(false);

  const dismiss = useCallback(() => {
    setCookie(
      COOKIE_NAME,
      COOKIE_VALUE,
      COOKIE_AGE,
      '/',
      config.security.cookies.domain,
      true
    );
  }, []);

  useEffect(() => {
    if (excluded) return;

    const timeoutId = setTimeout(() => {
      const isCookieNotificationSet = getCookie(COOKIE_NAME);
      if (!isCookieNotificationSet) setShow(true);
    }, TIMEOUT);

    return () => clearTimeout(timeoutId);
  }, [excluded]);

  if (!show) return null;

  return <Popup dismiss={dismiss} />;
};

const Wrapper = () => (
  <ClientOnly>
    <CookieConsent />
  </ClientOnly>
);

export default Wrapper;
